/**
 * Get the offset parent
 * @param {Element} element original element.
 * @return {Element} offset parent
 */
export function getOffsetParent (element) {
  const offsetParent = element.offsetParent
  const nodeName = offsetParent && offsetParent.nodeName.toLowerCase()
  if (!nodeName || nodeName === 'body' || nodeName === 'html') {
    return window.document.documentElement
  }
  return offsetParent
}

/**
 * Get computed CSS style
 * @param {Element} element element
 * @param {string=} property css property
 * @return {string|Object} css style value.
 */
export function getComputedStyle (element, property) {
  if (element.nodeType !== 1) {
    return []
  }
  const css = window.getComputedStyle(element, null)
  return property
  // https://github.com/jquery/jquery/blob/473d2ea7d5e4ef0a5b8e0305197f483c136ee4ab/src/css/curCSS.js#L21
  // getPropertyValue is needed for:
  //   util.getComputedStyle(element, 'filter') (IE 9 only, #12537)
  //   util.getComputedStyle(element, '--customProperty) (#3144)
    ? (css.getPropertyValue(property) || css[property])
    : css
}

export function addClass (element, clazz) {
  if (hasClass(element, clazz)) {
    return
  }
  element.className += ` ${clazz}`
}

export function removeClass (element, clazz) {
  clazz = clazz.replace(/([.*+?^=!:${}()|[\]\\-])/g, '\\$1')
  const regexp = new RegExp(`\\s*${clazz}(?=(?:\\s|$))`, 'g')
  element.className = element.className.replace(regexp, '')
}

export function hasClass (element, clazz) {
  clazz = clazz.replace(/([.*+?^=!:${}()|[\]\\-])/g, '\\$1')
  const regexp = new RegExp(`\\s*${clazz}(?=(?:\\s|$))`)
  return !!element.className.match(regexp)
}



// WEBPACK FOOTER //
// ./src/assets/js/dom.js